export default __webpack_public_path__ + "static/media/arrow-left.84e89ec5.svg";